import { v4 as uuid } from 'uuid';

export const MSG_USER_ROLE = { EMPLOYER: 'employer', CANDIDATE: 'candidate' };
export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed'
};

export const USER_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline'
};

export const createMessageData = (activeChatId, newMessage, activeChatInfo) => ({
  id: uuid(),
  recipientId: activeChatId,
  content: newMessage,
  recipientType: MSG_USER_ROLE.CANDIDATE,
  email: activeChatInfo.email,
  name: activeChatInfo.first_name,
  status: MESSAGE_STATUS.SENDING,
  messageType: 'text'
});

export const handleSocketResponse = (response) => {
  if (!response) {
    throw new Error('No response from server');
  }

  if (response.success) {
    return response.data;
  }

  const errorMessages = {
    AUTH_FAILED: 'You are not authorized. Please log in again.',
    VALIDATION_FAILED: 'Message format is invalid.',
    RATE_LIMITED: 'You are sending messages too quickly. Try again later.',
    INTERNAL_ERROR: 'Something went wrong. Please try again.',
    default: 'Something went wrong. Please try again.'
  };

  const message = response.message || errorMessages[response?.errorCode] || errorMessages.default;

  if (response.data) return response?.data;
  else return message;
};
